exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".KnRGC {\n  margin-top: 0 !important;\n  padding: 10px !important;\n}\n.KnRGC {\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"list": "KnRGC"
};